<template>
  <div>
    <div v-for="outputFrame in outputFrames" :key="outputFrame._key">
      <output-frame v-if="outputFrame.fragments.length > 0" :output-frame="outputFrame"></output-frame>
    </div>
  </div>
</template>

<script>
import OutputFrame from "./output-frame.vue";

export default {
  components: {
    OutputFrame
  },
  props: ["outputFrames"]
};
</script>
 

<style scoped>
</style>